import ContentPage from '../pages/Content';
import ModulosPage from '../pages/Modules';
import ContentLesson from '../pages/Lesson';
import MaterialPage from '../pages/Material';
import ExercisePage from '../pages/Exercise';
import ProtectedRoute from '../../../core/accessControl/ProtectedRoute';
import PlatformModules from '../../../core/accessControl/Modules';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ExerciseResolution from '../pages/ExerciseResolution';

const defaultModulesToAllow = [PlatformModules.NAVEGACAO_LIVRE_DISCIPLINAS.ID];

const RedirectComponent = () => {
  const { pathname } = useLocation();
  const { type, slug, discipline, module } = useParams();
  const navigate = useNavigate();

  if(pathname.includes('dossies-de-incidencias')) {
    const newPath = pathname.replace('assunto', 'modulo')+'/tipo/materiais';
    navigate(newPath);
  }

  if(type){
    const newPath = `/disciplinas/${discipline}/modulo/${module}/tipo/${type}`;
    navigate(newPath);
  }

  if(slug) {
    const newPath = pathname.replace('assunto', 'modulo').replace('conteudo', 'assunto');
    navigate(newPath);
  }

  if(!pathname.includes('conteudo')) {
    const newPath = pathname.replace('assunto', 'modulo')+"/tipo/videoaula";
    navigate(newPath);
  }

  return <></>
}

export const DisciplinesRoutes = [
  {
    path: ':discipline',
    element: <ModulosPage />,
  },
  {
    path: 'exercicio/:exercicio/resolucao',
    element: (
      <ProtectedRoute
        modulesAllowed={defaultModulesToAllow}
        element={<ExerciseResolution />}
      />
    ),
  },
  {
    path: ':discipline/modulo/:module/tipo/:type',
    element: <ContentPage />,
  },
  {
    path: ':discipline/modulo/:module/assunto/:subject/material/:slug',
    element: (
      <ProtectedRoute
        modulesAllowed={defaultModulesToAllow}
        element={<MaterialPage />}
      />
    ),
  },
  {
    path: ':discipline/modulo/:module/assunto/:subject/videoaula/:slug',
    element: (
      <ProtectedRoute
        modulesAllowed={defaultModulesToAllow}
        element={<ContentLesson />}
      />
    ),
  },
  {
    path: ':discipline/modulo/:module/assunto/:subject/exercicio/:slug',
    element: (
      <ProtectedRoute
        modulesAllowed={defaultModulesToAllow}
        element={<ExercisePage />}
      />
    ),
  },
  {
    path: ':discipline/assunto/:module/conteudo/:subject/tipo/:type',
    element: <RedirectComponent />,
  },
  {
    path: ':discipline/assunto/:module',
    element: <RedirectComponent />,
  },
  {
    path: ':discipline/assunto/:module/conteudo/:subject/material/:slug',
    element: (<RedirectComponent />),
  },
  {
    path: ':discipline/assunto/:module/conteudo/:subject/videoaula/:slug',
    element: (<RedirectComponent />),
  },
  {
    path: ':discipline/assunto/:module/conteudo/:subject/exercicio/:slug',
    element: (<RedirectComponent />),
  },
];
